import { render, staticRenderFns } from "./dialogFreeItem.vue?vue&type=template&id=59c1d1fc&scoped=true&"
import script from "./dialogFreeItem.vue?vue&type=script&lang=js&"
export * from "./dialogFreeItem.vue?vue&type=script&lang=js&"
import style0 from "./dialogFreeItem.vue?vue&type=style&index=0&id=59c1d1fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c1d1fc",
  null
  
)

export default component.exports